import React from 'react'
import { Link } from 'react-scroll';
import './Topcontent.css';

export const Topcontent = () => {
  return (
    <div className='topcontent'>
        <div className='topcontent-container'>
            <h1>Mr. MOHANRAJ VENKATACHAL<span className='spantag'>AM</span></h1>
            <p>A Professional Web and App Developer</p>
            <a href='https://drive.google.com/file/d/1gUJXI10EzFbdfGD241-XwE9vX4zr04CG/view?usp=sharing'>
                <button className='topcontent-downloadbutton'>Download CV</button>
            </a>
            <Link to='project' smooth={true} duration={500}>
            <button className='topcontent-myworkbutton'>My Work</button>
            </Link>
        </div>
    </div>
  )
}
